"use client";
import { useState, useRef, useEffect } from "react";
import style from "./Loginnew.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import { signup_Api, verifycode } from "../dashboardapi";
import CaptchaCanvas from "./Captcha"
const Signup = () => {
    // State for form fields
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [changingPassword, setChangingPassword] = useState(false);
    const [code, setCode] = useState("");
    const [generatedCaptcha, setGeneratedCaptcha] = useState("TS7QPC")
    const [captcha, setCaptcha] = useState("");
    const [verifyEmail, setVerifyEmail] = useState(false);
    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [captchaValue, setCaptchaValue] = useState(""); // Static captcha for demo

    const otpRefs = useRef([]);
    const toast = useToast();
    const navigate = useNavigate();
    const { loginpages } = useParams();

    // Initialize OTP refs
    useEffect(() => {
        otpRefs.current = otpRefs.current.slice(0, 6);
    }, []);

    // Handle OTP input change
    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (/^[0-9]?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (value && index < 5) {
                otpRefs.current[index + 1]?.focus();
            }
        }
    };

    // Handle OTP paste
    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
        if (pastedData.length > 0) {
            const newOtp = pastedData.split("").concat(new Array(6 - pastedData.length).fill(""));
            setOtp(newOtp);
            const focusIndex = Math.min(pastedData.length - 1, 5);
            otpRefs.current[focusIndex]?.focus();
        }
    };

    // Handle OTP backspace
    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newOtp = [...otp];
            if (!otp[index] && index > 0) {
                otpRefs.current[index - 1]?.focus();
                newOtp[index - 1] = "";
                setOtp(newOtp);
            } else if (otp[index]) {
                newOtp[index] = "";
                setOtp(newOtp);
            }
        }
    };

    const handleChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return; // Only allow single digit

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next box automatically
        if (value !== "" && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "" && index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const data = e.clipboardData.getData("text");
        const numbers = data.replace(/\D/g, "").slice(0, 6).split("");

        const newOtp = [...otp];
        numbers.forEach((num, i) => {
            newOtp[i] = num;
        });

        setOtp(newOtp);

        // Focus last filled input
        const lastIndex = numbers.length - 1;
        if (inputRefs.current[lastIndex]) {
            inputRefs.current[lastIndex].focus();
        }
    };


    // Handle signup form submission
    const handleSignupSubmit = async (e) => {
        e.preventDefault();
        if (captcha !== captchaValue) {
            toast({
                title: "Invalid Captcha",
                description: "Please enter the correct captcha value.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
            return;
        }
        try {
            const result = await signup_Api(name, email, password, confirmpassword);
            if (result.data) {
                toast({
                    title: "Verification Code Sent",
                    description: result.data.message,
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                setVerifyEmail(true);
            } else {
                toast({
                    title: "Signup Failed",
                    description: result.error.message,
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Signup Failed",
                description: "An error occurred. Please try again.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        }
    };

    // Handle OTP verification
    const handleVerifyOTP = async () => {

        try {
            const result = await verifycode(email, code);
            if (result.data) {
                toast({
                    title: "Email Verified",
                    description: "Your email has been verified successfully!",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                // navigate("/dashboard");
            } else {
                toast({
                    title: "Verification Failed",
                    description: result.error.message,
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Verification Failed",
                description: "An error occurred. Please try again.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        }
    };


    const handleSignUp = async (e) => {
        e.preventDefault();
        console.log("the captcahe and the captchavalue is:", captcha, captchaValue);
        if (changingPassword) {
            if (captchaValue.trim() !== generatedCaptcha.trim()) {
                toast({
                    title: "Invalid Captcha",
                    description: "Please enter the correct captcha value.",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
                return;
            }
        }

        try {
            let result = await signup_Api("signUp", email, password, confirmpassword);
            if (result.data) {
                if (result.data.status === "email") {
                    toast({
                        title: "Verification Code sent to your email",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    setVerifyEmail(true);
                    // if (loginpages === "signIn") {
                    //     navigate("/loginnew/signIn/verifyCode")
                    // } else {
                    //     navigate("/loginnew/signUp/verifyCode")
                    // }
                }
                if (result.data.status === "complete") {
                    toast({
                        title: "",
                        description: result.data.message,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    console.log("process completed")
                    navigate("/signIn");
                }
            } else {
                let error = result.error.message
                toast({
                    title: "signUp failed",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "signUp failed",
                description: "Failed to signUp please try again",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const verifycodeapi = async (e) => {
        e.preventDefault();

        let result = await verifycode("signUp", email, otp.join(""))
        if (result.data) {
            // console.log(result.data);
            toast({
                title: "Code verified successfully",
                status: "success",
                duration: 2000,
                isClosable: true,
            })
            setChangingPassword(true);

            // navigate(`/loginnew/${loginpages}/confirmPassword`)
        } else {
            let error = result.error.message
            toast({
                title: 'Verification unsuccessfull',
                description: error,
                status: 'error',
                duration: 2000,
                isClosable: "true"
            })

        }
    }
    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        let code = "";
        for (let i = 0; i < 6; i++) {
            code += chars[Math.floor(Math.random() * chars.length)];
        }
        setGeneratedCaptcha(code);
    };


    return (
        <div className="container">
            <div className={style.signinpagecontainer}>



                <div className={style.firsthalf}>
                    <div className={style.loginlogocontainer}>
                        <Link to={"/home"}>
                            <img
                                src={process.env.PUBLIC_URL + "/NewPages/Homepage/TransformaLogo.png"}
                                alt="Transforma Logo"
                                className={style.LoginLogo}
                            />
                        </Link>
                    </div>
                    <div className={style.formcontainer}>
                        {(verifyEmail && !changingPassword) ? (
                            <div style={{ textAlign: "center", display: "flex", gap: "12px", flexDirection: "column" }}>
                                <h1>Check your Email</h1>
                                <p>Please enter the six digit verification code we sent to</p>
                                <strong>{email}</strong>
                            </div>
                        ) : (
                            <div style={{ textAlign: "center" }}>
                                <h1>Create an Account</h1>
                                <p>Please enter your details to create an account</p>
                            </div>
                        )}

                        {
                            (!verifyEmail && !changingPassword) && (
                                <form onSubmit={handleSignUp}>

                                    <div className={style.logincombine}>
                                        <label>Email *</label>
                                        <input
                                            type="email"
                                            placeholder="e.g. siva21@gmail.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <button type="submit" className={style.signupButton}>
                                        Verifiy Email
                                    </button>
                                    <div className={style.signupnavigator}>
                                        <p className={style.create}>Already have an account?</p>
                                        <Link to="/signin" style={{ color: "#f44f0d", fontWeight: "bold" }}>
                                            Sign In
                                        </Link>
                                    </div>
                                    <div className={style.signupnavigator}>
                                        <button type="button" style={{ background: "transparent", margin: "0px" }} onClick={() => { navigate("/home") }}>
                                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.21967 4.99262C-0.0732233 5.28551 -0.0732233 5.76039 0.21967 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.0732449 5.28553 -0.0732449 4.99264 0.219648L0.21967 4.99262ZM16.75 6.27295C17.1642 6.27295 17.5 5.93716 17.5 5.52295C17.5 5.10874 17.1642 4.77295 16.75 4.77295V5.52295V6.27295ZM0.75 5.52295V6.27295H16.75V5.52295V4.77295H0.75V5.52295Z" fill="#15141C" />
                                            </svg>
                                            <p className={style.forgetPassword}>


                                                <span style={{ fontWeight: "bold" }}>B</span>ack to Site</p>
                                        </button>

                                    </div>
                                </form>
                            )
                        }
                        {
                            (verifyEmail && !changingPassword) && (
                                // (verifyEmail && true) && (
                                <>
                                    <form onSubmit={verifycodeapi}>

                                        <div style={{ display: "flex", gap: "10px", marginTop: "40px", marginBottom: "40px", justifyContent: "center", }}>
                                            {otp.map((value, index) => (
                                                <input
                                                    key={index}
                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                    type="text"
                                                    maxLength={1}
                                                    value={value}
                                                    onChange={(e) => handleChange(e.target.value, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={handlePaste}
                                                    className={style.otpInputBox}
                                                    style={{
                                                        width: "48px",
                                                        height: "48px",
                                                        textAlign: "center",
                                                        fontSize: "25px",
                                                        border: "1px solid #D9D7DE",
                                                        borderRadius: "12px",
                                                    }}
                                                />
                                            ))}
                                        </div>
                                        <button type="submit" className={style.signupButton} >
                                            Continue
                                        </button>

                                    </form>
                                    <div className={style.signupnavigator}>
                                        <button style={{ background: "transparent", margin: "0px" }} onClick={() => { setVerifyEmail(false) }}>
                                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.21967 4.99262C-0.0732233 5.28551 -0.0732233 5.76039 0.21967 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.0732449 5.28553 -0.0732449 4.99264 0.219648L0.21967 4.99262ZM16.75 6.27295C17.1642 6.27295 17.5 5.93716 17.5 5.52295C17.5 5.10874 17.1642 4.77295 16.75 4.77295V5.52295V6.27295ZM0.75 5.52295V6.27295H16.75V5.52295V4.77295H0.75V5.52295Z" fill="#15141C" />
                                            </svg>
                                            <p className={style.forgetPassword}>


                                                Back</p>
                                        </button>

                                    </div>
                                </>
                            )
                        }
                        {
                            changingPassword && (
                                <>
                                    <form onSubmit={handleSignUp}>


                                        <div className={style.logincombine}>
                                            <label>Password *</label>
                                            <div className={style.passwordContainer}>


                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                                <div className={style.eyeIcon} >
                                                    <button style={{ background: "transparent", margin: "0px" }} className={style.eyeIconButton} type='button' onClick={() => { setShowPassword(!showPassword) }}>
                                                        {
                                                            !showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6" clip-path="url(#clip0_897_1766)">
                                                                    <path d="M10.5846 10.5869C10.2096 10.9621 9.99893 11.4708 9.99902 12.0013C9.99912 12.5317 10.2099 13.0404 10.5851 13.4154C10.9602 13.7904 11.469 14.0011 11.9994 14.001C12.5299 14.0009 13.0386 13.7901 13.4136 13.4149" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88003 5.712 8.32203 7.32 7.32603M10.18 6.18003C10.779 6.05876 11.3888 5.99845 12 6.00003C15.6 6.00003 18.6 8.00003 21 12C20.334 13.11 19.621 14.067 18.862 14.87" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 3L21 21" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_897_1766">
                                                                        <rect width="24" height="24" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6">
                                                                    <path d="M2.06153 12.3479C1.97819 12.1234 1.97819 11.8764 2.06153 11.6519C2.87323 9.68373 4.25104 8.00091 6.0203 6.81677C7.78955 5.63263 9.87057 5.00049 11.9995 5.00049C14.1285 5.00049 16.2095 5.63263 17.9788 6.81677C19.748 8.00091 21.1258 9.68373 21.9375 11.6519C22.0209 11.8764 22.0209 12.1234 21.9375 12.3479C21.1258 14.316 19.748 15.9988 17.9788 17.183C16.2095 18.3671 14.1285 18.9993 11.9995 18.9993C9.87057 18.9993 7.78955 18.3671 6.0203 17.183C4.25104 15.9988 2.87323 14.316 2.06153 12.3479Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                            </svg>

                                                        }

                                                    </button>

                                                </div>

                                            </div>
                                        </div>
                                        <div className={style.logincombine}>
                                            <label>Confirm Password *</label>
                                            <div className={style.passwordContainer}>


                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    placeholder="Enter your password"
                                                    value={confirmpassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required
                                                />
                                                <div className={style.eyeIcon} >
                                                    <button style={{ background: "transparent", margin: "0px" }} className={style.eyeIconButton} type='button' onClick={() => { setShowConfirmPassword(!showConfirmPassword) }}>
                                                        {
                                                            !showConfirmPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6" clip-path="url(#clip0_897_1766)">
                                                                    <path d="M10.5846 10.5869C10.2096 10.9621 9.99893 11.4708 9.99902 12.0013C9.99912 12.5317 10.2099 13.0404 10.5851 13.4154C10.9602 13.7904 11.469 14.0011 11.9994 14.001C12.5299 14.0009 13.0386 13.7901 13.4136 13.4149" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16.681 16.673C15.2782 17.5507 13.6547 18.0109 12 18C8.4 18 5.4 16 3 12C4.272 9.88003 5.712 8.32203 7.32 7.32603M10.18 6.18003C10.779 6.05876 11.3888 5.99845 12 6.00003C15.6 6.00003 18.6 8.00003 21 12C20.334 13.11 19.621 14.067 18.862 14.87" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 3L21 21" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_897_1766">
                                                                        <rect width="24" height="24" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.6">
                                                                    <path d="M2.06153 12.3479C1.97819 12.1234 1.97819 11.8764 2.06153 11.6519C2.87323 9.68373 4.25104 8.00091 6.0203 6.81677C7.78955 5.63263 9.87057 5.00049 11.9995 5.00049C14.1285 5.00049 16.2095 5.63263 17.9788 6.81677C19.748 8.00091 21.1258 9.68373 21.9375 11.6519C22.0209 11.8764 22.0209 12.1234 21.9375 12.3479C21.1258 14.316 19.748 15.9988 17.9788 17.183C16.2095 18.3671 14.1285 18.9993 11.9995 18.9993C9.87057 18.9993 7.78955 18.3671 6.0203 17.183C4.25104 15.9988 2.87323 14.316 2.06153 12.3479Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#3D3D41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                            </svg>

                                                        }

                                                    </button>

                                                </div>

                                            </div>
                                        </div>
                                        <div className={style.logincombine}>
                                            <label>Verification Captcha</label>
                                            <div className={style.captcha}>
                                                <div className={style.captchaandRecaptacha}>
                                                    <div className={style.captchvalue}>
                                                        <CaptchaCanvas text={generatedCaptcha} />
                                                    </div>
                                                    <img
                                                        src={process.env.PUBLIC_URL + "/NewPages/Homepage/recaptcha.png"}
                                                        alt="Captcha Reload"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={generateCaptcha}
                                                    />
                                                </div>

                                                <input
                                                    type="text"
                                                    placeholder="Type the characters above"
                                                    value={captchaValue}
                                                    onChange={(e) => setCaptchaValue(e.target.value)}
                                                    required
                                                    onPaste={(e) => { e.preventDefault() }}
                                                />
                                            </div>
                                        </div>

                                        <button type="submit" className={style.signupButton}>
                                            Sign Up
                                        </button>

                                    </form>
                                    <div className={style.signupnavigator}>
                                        <button style={{ background: "transparent", margin: "0px" }} onClick={() => { setChangingPassword(false); setEmail(""); setPassword(""); setConfirmPassword(""); setCaptcha("") }}>
                                            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.21967 4.99262C-0.0732233 5.28551 -0.0732233 5.76039 0.21967 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.0732449 5.28553 -0.0732449 4.99264 0.219648L0.21967 4.99262ZM16.75 6.27295C17.1642 6.27295 17.5 5.93716 17.5 5.52295C17.5 5.10874 17.1642 4.77295 16.75 4.77295V5.52295V6.27295ZM0.75 5.52295V6.27295H16.75V5.52295V4.77295H0.75V5.52295Z" fill="#15141C" />
                                            </svg>
                                            <p className={style.forgetPassword}>


                                                Back</p>
                                        </button>

                                    </div>
                                </>
                            )
                        }

                    </div>
                </div>

                <div className={style.signupimage}>
                    <img
                        src={process.env.PUBLIC_URL + "/NewPages/Homepage/LoginBackground.png"}
                        alt="Login Background"
                    />
                </div>
            </div>
        </div>
    );
};

export default Signup;


